export default "__VITE_ASSET__BWafxXzr__"